module.exports = __webpack_public_path__ + "static/media/MS.26255278.png";